import axios, { AxiosResponse } from 'axios';
import { ENDPOINTS } from '@/constants/routes';
import { UpdateUserDto, UserDto } from '@/lib/api/schemas/user.schema';

export const getProfile = (): Promise<AxiosResponse<UserDto>> => {
    return axios.get(ENDPOINTS.Profile);
};

export const setUserData = (data: UpdateUserDto) => {
    return axios.patch(ENDPOINTS.User, data);
};
